import { createSlice } from "@reduxjs/toolkit";
import { signInUser , isAuth, signOut} from "../actions/users";



let DEFAULT_USER_STATE = {
    loading: false,
    data: {
        userid: null,
        userEmail: null,
        userName: null,
        password: null,
        roleId: null,
    },
    auth: null,
};

export const userSlice = createSlice({
    name: 'users',
    initialState: DEFAULT_USER_STATE,
    reducers: {
        // Your additional reducers can go here if needed
    },
    extraReducers: (builder) => {
        builder
            .addCase(signInUser.pending, (state) => { state.loading = true })
            .addCase(signInUser.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.auth = action.payload.auth;
            })
            .addCase(signInUser.rejected, (state) => { state.loading = false })
            
            // isAuth
            .addCase(isAuth.pending, (state) => { state.loading = true })
            .addCase(isAuth.fulfilled, (state, action) => {
                state.loading = false;
                state.data = {...state.data, ...action.payload.data};
                state.auth = action.payload.auth;
            })
            .addCase(isAuth.rejected, (state) => { state.loading = false })

            // Signout

            .addCase(signOut.fulfilled, (state) => {
                state.loading = false;
                state.data = DEFAULT_USER_STATE.data;
                state.auth = false;
            })

        
            
    },  
});

export default userSlice.reducer;
